
import { useTranslation } from "react-i18next";
import { Table, SORT } from '../components/Table'
import { useEffect, useState, useRef } from 'react';
import { axiosInstance } from '../common/utils';
import {useSelector, useDispatch} from 'react-redux'
import Modal from 'react-bootstrap/Modal';
import { ModalConfirmation } from '../components/ModalConfirmation';
import { ModalWarning } from '../components/ModalWarning';
import { toast } from 'react-toastify';
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useLocation, useNavigate } from "react-router-dom"
import routes from '../common/routes'
import { useSearchParams } from 'react-router-dom';


const InfluxDBServerModal = (props) => {
  const { t } = useTranslation();
  const [ influxDBServer, setInfluxDBServer ] = useState({
    name: '', description: '', url: ''
  });

  const onSave = async () => {
    try{
      // Create
      if( props.targetUuid == null){
        await axiosInstance.post(`/api/v1/influxdb_servers/`, {...influxDBServer});
      }

      // Update
      if( props.targetUuid ){
        await axiosInstance.put(`/api/v1/influxdb_servers/${props.targetUuid}/`, {...influxDBServer});
      }

      // Call parent
      props.onSave();
      toast.success(t('request_succeded'))
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  useEffect( () => {
    ( async () => {
      try{
        if( props.targetUuid == null){
          setInfluxDBServer({ name: '', description: '', url: '' })
          return
        }


        if( props.targetUuid){
          const response = await axiosInstance.get(`/api/v1/influxdb_servers/${props.targetUuid}/`);
          setInfluxDBServer({...response.data})
          return
        }
      }catch(e){   
        toast.error(t('request_failed'))   
      }
    })();

  }, [props.show, props.targetUuid, t])


  const operation = props.targetUuid?t('edit'):t('add')
  return (<Modal show={props.show} onHide={() => props.onCancel()} centered>
            <Modal.Header closeButton>
              <Modal.Title>{operation} {t('influxdb_server')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group">
                <label>{t('name')}</label>
                <input type="text" className="form-control mt-2" 
                  value={influxDBServer.name} onChange={(e) => setInfluxDBServer({...influxDBServer, name: e.target.value})} />
              </div>
              <div className="form-group">
                <label>{t('description')}</label>
                <input type="text" className="form-control mt-2" 
                  value={influxDBServer.description} onChange={(e) => setInfluxDBServer({...influxDBServer, description: e.target.value})} />
              </div>
              <div className="form-group">
                <label>{t('url')}</label>
                <input type="text" className="form-control mt-2" 
                  value={influxDBServer.url} onChange={(e) => setInfluxDBServer({...influxDBServer, url: e.target.value})} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button" className="btn btn-secondary"
                onClick={() => props.onCancel()}>
                {t('cancel')}
              </button>
              <button type="button" className="standalone-button btn btn-primary"
                onClick={() => onSave()}>
                {t('save')}
              </button>
            </Modal.Footer>
          </Modal>)
}

export const InfluxDBServer = () => {
  const { t } = useTranslation();
  const [data, setData] = useState({ count: 0, results: []})
  const [loading, setLoading] = useState(false)
  const [showDetail, setShowDetail] = useState(false)
  const targetUuid = useRef(null)
  const pageSizeRef = useRef(10);
  const offsetRef = useRef(0);
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showWarning, seShowWarning] = useState(false)
  const user = useSelector(state => state.main.user)
  const parameters = useRef({})
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();


  const headers = [
    { key: 'name', title: t('name'), sort: SORT.DEFAULT },
    { key: 'description', title: t('description'), sort: SORT.DEFAULT },    
    { key: 'url', title: t('url'), sort: SORT.DEFAULT, className: 'text-center', 
      rendering: (uuid, item) => { 
        return <div className='text-center'> 
                  <a href={item} style={{ color: 'black'}}>
                    <FontAwesomeIcon icon={faLink} style={{ fontSize: '20px'}} />
                  </a>
                </div>
        }
    },
    { key: 'calc_influx_db_credentials', title: t('calc_influx_db_credentials'), sort: SORT.DEFAULT, className: 'text-center',
      rendering: (uuid, item) => {
        return <div className='text-center'>
                  <span className="badge bg-primary"  onClick={() => navigate( routes.influxdb_credential.url(uuid) )}>
                  {item} credentials
                  </span>
                </div>
      },
    }
  ]

  const refresh = async (limit, offset, parameters = {}) => {
    try{
      setLoading(true)
      const urlParams = new URLSearchParams(parameters).toString();
      const response = await axiosInstance.get(`/api/v1/influxdb_servers/?limit=${limit}&offset=${offset}${urlParams.length>0?`&${urlParams}`:''}`);
      setData(response.data)
      setLoading(false)
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  useEffect( () => {
    refresh(pageSizeRef.current, offsetRef.current)
  }, [user]);

  useEffect( () => {
    if( searchParams.get('uuid') == null ) return
    // Show selected server
    targetUuid.current = searchParams.get('uuid')
    setShowDetail(true)
  }, [searchParams])


  // -------------------
  // Handlers
  // -------------------

  const onPageChange = async (pageSize, page) => {
    // Store parameters
    pageSizeRef.current = pageSize;
    offsetRef.current = pageSize*page;
    // Refresh
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onSortClick = async (key, direction, pageSize, page) => {
    const prefix = direction === SORT.DOWN?"-":""
    parameters.current = { ...parameters.current, ordering : `${prefix}${key}` }
    pageSizeRef.current = pageSize;
    offsetRef.current = page;
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onSearch = (pattern, pageSize, page) => {
    parameters.current = { ...parameters.current, search : pattern }
    pageSizeRef.current = pageSize;
    offsetRef.current = page;
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
  }

  const onClickEdit = (uuid) => {
    targetUuid.current = uuid;
    setShowDetail(true)
  }

  const onClickDelete = (uuid) => {
    const obj = data.results.find( item => item.uuid === uuid );
    if(obj.calc_influx_db_credentials > 0 ){
      seShowWarning(true)
      return
    }

    // Proceed to delete
    targetUuid.current = uuid;
    setShowConfirmation(true)
  }

  const onDeleteProceed = async () => {
    try{
      setShowConfirmation(false)

      await axiosInstance.delete(`/api/v1/influxdb_servers/${targetUuid.current}/`);

      // Refresh
      refresh(pageSizeRef.current, offsetRef.current, parameters.current)
      toast.success(t('request_succeded'))
    }catch(e){   
      toast.error(t('request_failed'))   
    }
  }

  const onClickAdd = () => {
    targetUuid.current = null;
    setShowDetail(true)
  }
  
  const onSaveCompleted = () => {
    // Refresh
    refresh(pageSizeRef.current, offsetRef.current, parameters.current)
    setShowDetail(false)
  }

  return <div className='h-100'>
          <Table data={data} headers={headers} 
            onSortClick={ (key, direction, pageSize, page) => onSortClick(key, direction, pageSize, page)} 
            onClickRow={(id) => onClickEdit(id)} 
            onClickDelete={(id) => onClickDelete(id)} 
            onClickAdd={() => onClickAdd()} 
            onPageChange={(pageSize, page) => onPageChange(pageSize, page)} 
            loading={loading} 
            onSearch={(pattern, pageSize, page) => onSearch(pattern, pageSize, page)} />

          <ModalConfirmation title={`${t('delete')} ${t('influxdb_server')}`} 
            onCancel={() => setShowConfirmation(false)} 
            onProceed={() => onDeleteProceed()}
            show={showConfirmation} />

          <ModalWarning title={t('warning')}
            message={t('dependent_credentials')}
            show={showWarning} 
            onProceed={() => seShowWarning(false)}
            />

          <InfluxDBServerModal show={showDetail} 
            onCancel={() => setShowDetail(false)}
            onSave={() => onSaveCompleted()}
            targetUuid={targetUuid.current}
            />

        </div>    
  
}
